module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/speaker-67ec9e581ffe58c02caf9841a786a47a.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/speaker.svg
// module id = Gjqj
// module chunks = 24